import { render, staticRenderFns } from "./ClientCorsOriginSave.vue?vue&type=template&id=455c4cde&scoped=true&"
import script from "./ClientCorsOriginSave.vue?vue&type=script&lang=ts&"
export * from "./ClientCorsOriginSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c4cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455c4cde')) {
      api.createRecord('455c4cde', component.options)
    } else {
      api.reload('455c4cde', component.options)
    }
    module.hot.accept("./ClientCorsOriginSave.vue?vue&type=template&id=455c4cde&scoped=true&", function () {
      api.rerender('455c4cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientCorsOrigin/ClientCorsOriginSave.vue"
export default component.exports